module.exports = __webpack_public_path__ + "static/oscar-icon-c73d7fe5f179717ef1b732ba65a585df.png";